export default {
  ACTIVATION_EXPIRED: -1,
  ACTIVATION_EXPIRING: 15,
  ACTIVATION_NEW: 30,
  EBOOK_NEW: 15,
  EVALUATION_EXPIRED: -1,
  EVALUATION_EXPIRING: 15,
  EVALUATION_NEW: 30,
  INDEX_NEW: 15,
};
